/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { sort, alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';
import type Category from 'linced-admin/models/goals/category';
import type Goal from 'linced-admin/models/goals/goal';
import type Subject from 'linced-admin/models/goals/subject';
import type School from 'linced-admin/models/school';

// Proto: goals.GoalSubcategoryTemplate.
export default class Subcategory extends Model {
  declare [Type]: 'goals/subcategory';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string')
  declare campusId: string | undefined; // TODO: implement when we have Campuses

  @attr('boolean', { defaultValue: false })
  declare isPublished: boolean;

  @belongsTo('goals/subject', { async: true, inverse: null })
  declare subjectId: AsyncBelongsTo<Subject>;

  @alias('subjectId')
  declare subject: AsyncBelongsTo<Subject>;

  @attr('boolean', { defaultValue: false })
  declare isPLP: boolean;

  @belongsTo('goals/category', { async: true, inverse: 'subcategories' })
  declare categoryId: AsyncBelongsTo<Category>;

  @alias('categoryId')
  declare category: AsyncBelongsTo<Category>;

  @hasMany('goals/goal', { async: true, inverse: 'subcategoryId' })
  declare goals: AsyncHasMany<Goal>;

  @computed('goals.content.[]')
  get goalsArray() {
    return resolved(this.goals);
  }

  goalSortOrder = Object.freeze(['sequence', 'label']);

  @sort('goalsArray', 'goalSortOrder')
  declare sortedGoals: unknown[];

  @computed('sortedGoals.[]', 'categoryId')
  get sortedBoundGoals() {
    const goals: unknown[] & {
      __category__?: unknown;
      __subcategory__?: Subcategory;
    } = this.sortedGoals.slice();
    // The loaded category, not the async relationship's proxy: sortDragEnd
    // sets it as categoryId, and WarpDrive rejects a proxy there.
    goals.__category__ = (this as Subcategory).belongsTo('categoryId').value();
    goals.__subcategory__ = this;
    return goals;
  }

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('boolean', { defaultValue: false })
  declare isLocked: boolean;

  @attr('string')
  declare templateId: string | undefined; // TODO: implement once Templates are added

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare description: string;
}
